import { COLORS } from '../../theme';
import { relativeTime } from '../../lib/format';
import { formatValue } from '../../lib/opsFormat';
import type { AuditRow } from '../../lib/opsOverview';
import { Table, Td, EmptyRow } from './table';

// Section 3 — Recent Activity. Read from ops_switch_audit, newest first.
const COLUMNS = ['Time', 'Actor', 'Switch', 'Reason', 'Old', 'New'];

export function AuditTable({ rows }: { rows: AuditRow[] }) {
  return (
    <Table columns={COLUMNS}>
      {rows.length === 0 ? (
        <EmptyRow span={COLUMNS.length} label="No switch changes recorded yet." />
      ) : (
        rows.map((r, i) => (
          <tr key={`${r.at}-${r.key}-${i}`}>
            <Td nowrap title={r.at}>{relativeTime(r.at)}</Td>
            <Td mono nowrap>{r.actor}</Td>
            <Td mono color={COLORS.text} nowrap>{r.key}</Td>
            <Td>{r.reason ?? '—'}</Td>
            <Td mono>{formatValue(r.old_value)}</Td>
            <Td mono color={COLORS.text}>{formatValue(r.new_value)}</Td>
          </tr>
        ))
      )}
    </Table>
  );
}
